
export default {
    //页面的英文内容
    menu: {
        home: 'Data Statistics',
        goods: 'Goods Manage',
        params: 'Specification',
        advert: 'Classification of advertising',
        order: 'The order management',
        orderlist: 'The order list',
        orderback: 'Returns management'
    },
    home: {
        ApprovalTime: "Approval Time:",
        country: "Country:",
        disease: "Disease:",
        // DrugList:"Drug List",
        see: "View",
        service: "Service",
        centerintro: "Center",
        Expertteam: "Experts",
        Partners: "Partners",
        Partners2: "Cooperative Hospital",
        Newsandinformation: "News",
        Consultationcooperation: "Consultation",
        Gocheck: "View",
        Gocheck2: "Learn More",
        Patientcounseling: "Patient",
        Doctorcollaboration: "Doctor",
        Manufacturercooperation: "Manufacturer",
        WeChatofficialaccount2: "Scan to follow the official account",
        MicroBlog: "Weibo",
        WeChatOfficialAccount: "Official Account",
        OurStory: "OurStory",
        Diagnosisandtreatmentservices: "Diagnosisandtreatmentservices",
        Cooperativeprojects: "Cooperativeprojects",
        PopularScienceInformation: "PopularScienceInformation",
        AcademicFrontiers: "AcademicFrontiers",
        PatientHome: "PatientHome",
        ContactUs: "ContactUs",
        VisionandMission: "VisionandMission",
        developmenthistory: "developmenthistory",
        Listsofdiseases: "Listsofdiseases",
        DrugList: "Medicines List",
        newsInfo: "News Information",
        messageInfo: 'Message Information',
        Findmedicineandmedication: "Findmedicineandmedication",
        Globaldrugsearch: "Globaldrugsearch",
        scientificresearchcooperation: "scientificresearchcooperation",
        Expertcooperation: "Expertcooperation",
        Cooperation: "Cooperation",
        WeiaiBaidu: "WeiaiBaidu",
        MedicalPolicy: "MedicalPolicy",
        DaKaHanHua: "DaKaHanHua",
        LiteratureandInformation: "LiteratureandInformation",
        CaseStudy: "CaseStudy",
        ConferenceNewLanguage: "ConferenceNewLanguage",
        BigCoffeeSalon: "BigCoffeeSalon",
        readin: "Read in",
        PublicWelfareProjects: "PublicWelfareProjects",
        InsuranceAndPayment: "InsuranceAndPayment",
        PatientStories: "PatientStories",
        TransportationGuidelines: "TransportationGuidelines",
        PatientCounseling: "Patient Counseling",
        DoctorCollaboration: "Doctor Collaboration",
        ManufacturerCooperation: "Manu Cooperation",
        CompanyAddress: "Address",
        understand: "View",
        Address: "Address",
        Telephone: "Telephone",
        mailbox: "Mail",
        name: "Name",
        age: "Age",
        contactInformation: "ContactInformation",
        gender: "Gender",
        diagnose: "Diagnose",
        ConsultationContentorrequiredDrugs: "Drug in need",
        male: "Male",
        female: "Female",
        baomi: "secrecy",
        notes: "Remarks",
        organization: "Organization",
        CooperationType: "CooperationType",
        submit: "Submit",
        submit1: "Submitted successfully",
        Doctorsmessage: "Doctorsmessage",
        Cooperation: "Cooperation",
        seek: "Seek",
        Topping: "Top",
        Follow: "Follow",
        Follow1: "Follow the official account with WeChat QR code to get more information",
        Follow2: "Got it",
        Follow3: "Scan QR code to follow WeChat official account",
        Follow4: "Automatically close and redirect to the drug",
        Follow5: "Jump immediately",
        ReadAndAgree: "Read and agree",
        Patientinformedconsentformpolicy: "Patient informed consent form&privacy policy",
        Please1: "Please enter your name",
        Please2: "Please enter Chinese/English",
        Please3: "Please select gender",
        Please4: "Please enter age",
        Please5: "please enter a number",
        Please6: "Please enter your phone number or landline number",
        Please7: "Please enter your email address",
        Please8: "Please enter the organization",
        Search: "Search",
        Article: "Article",
        Video: "Video",
        Expert: "Expert",
        bottom1: "Find Medicine & Consultation",
        bottom2: "Academic Activities, Real World Study",
        bottom3: "Clinical Research & Registration",
        bottom4: "Get more information",
        CH: "CH",
        login: "Login",
        Modify: "Modify data",
        logout: "Logout",
        Bind: "Bind phone number",
        Obtain: "Obtain verification code",
        please: "Please enter your phone number",
        please1: "Please input and see the verification code",
        please2: "Please enter the verification code you received",
        save: "Save",
        logged: "Unable to watch videos without logging in",
        Flinks: "Links",
        qcode: "WeChat QR for quick login",
        qcode1: "By logging in, you have agreed to the Service Agreement and Privacy Policy",
        agreen: "Agree to the",
        agreen1: "Informed Consent",
        agreen2: "Privacy Policy",
        needs: 'The staff will contact you within 3-5 working days. For urgent needs, please contact the center directly at 0898-62799961',
        MessageConsultation: "Seek",
        latest: "latest",
        hottest: "hottest",
        subscribe: "subscribe",
    },
    disease: {
        DiseaseTopic: 'DiseaseTopic',
        classificationOfDisease: 'Category',
    },
    drug: {
        DrugList: 'DrugList',
        more: 'More',
        label: 'Label',
        classification: 'Category',
        allData: 'All',
        UpcomingEvents: 'Upcoming Events',
        control:'Manage subscriptions',
        cancelControl:'unsubscribe'
    },
    medic: {
        CoreServices: 'CoreServices',
        PatientCounseling: 'Patient Counseling',
    },
    exteam: {
        ExpertTeam: 'ExpertTeam',
        Department: 'Department',
    },
    visitprocess: {
        VisitProcess: 'Processes',
        TransportationMode: 'TransportationMode',
        theBus: 'The Bus',
        ParkShuttle: 'ParkShuttle',
    },
    literature: {
        AcademicList: 'AcademicList',
    },
    no: {
        Thereiscurrentlynocontentavailable: 'There is currently no content available',
        Youcanclickthebuttonbelowtoleaveamessageforconsultation: 'MessageConsultation',
        MessageConsultation: 'MessageConsultation',
        pleaseLogin: 'pleaseLogin',
    },
    love: {
        EncyclopediaList: 'EncyclopediaList',
    },
    policy: {
        PolicyList: 'PolicyList',
    },
    shout: {
        Listofrarewords: 'Listofrarewords',
    },
    story: {
        NewsList: 'NewsList',
    },
    contact: {
        content: 'Thank you for your attention to the official website of Boao Lecheng Weijian Rare Disease Clinical Medical Center. You can contact us by calling our service hotline or email, and we will wholeheartedly provide you with satisfactory services'
    },
    intro: {
        VisionAndMission: 'VisionAndMission',
        History: 'History',
        Partners: 'Partners',
        NewsCenter: 'NewsCenter',
        SeeMore: 'SeeMore',
    },
    details: {
        host: 'Host',
        LiveTime: 'LiveTime',
        WatchNow: 'Watch live streaming',
        WatchNow1: 'Not started',
        WatchNow2: 'View',
        SeeMore: 'Introduction',
        Liveintroduction: 'Related',
        MessageConsultation: 'Contact',
        experts: 'Experts',
        academicResearch: 'AcademicResearch',
        RelatedArticles: 'RelatedArticles',
        RelatedProducts: 'RelatedProducts',
        RelatedDrugs: 'Related drugs',
        RelatedExperts: 'RelatedExperts',
        latestNews: 'LatestNews',
        LatestVideo: 'LatestVideo',
        ClickThebuttonBelowtoContactUs: 'Click The button contact us',
        MessageConsultation: 'MessageConsultation',
        subscribe: 'Click subscribe obtain information',
        subscribe2: 'subscribe'
    },
    seek: {
        ConsultationType: "Consultation Type"
    }
}